import {
    StyleSheet,
    Text,
    View,
    Svg,
    Path,
    Page
  } from "@react-pdf/renderer";
  import {
    filter as _filter,
    chunk as _chunk,
    slice as _slice,
  } from "lodash";
  import moment from "moment";
  import { useEffect, useState } from "react";
  import { convertCentsIntoDollar, formatDate } from "../../../../helpers/genericHelper";
  
  const styles = StyleSheet.create({
    table: {
      width: "100%",
      border: "1px solid black",
      padding: "3%",
    },
  
    row: {
      display: "flex",
      flexDirection: "row",
      borderTop: "1px solid #EEE",
      paddingTop: 8,
      paddingBottom: 8,
    },
    section2: {
      paddingTop: "5%",
      paddingBottom: "5%",
    },
    header: {
      borderTop: "none",
    },
    bold: {
      fontWeight: "bold",
    },
    // So Declarative and unDRY 👌
    row1: {
      width: "27%",
      fontSize: 15,
    },
    row5: {
      width: "27%",
      fontSize: 10,
    },
    row5Due: {
      width: "27%",
      fontSize: 10,
      color: 'red'
    },
    balanceDue: {
      width: "27%",
      fontSize: 14,
      color: 'red'
    },
    text: {
      textAlign: "center",
      fontSize: 10,
      margin: 30,
      color: 'black'
    },
    section1: { fontSize: 14, marginTop: "2%" },
    section1Bold: {
      fontSize: 14, marginTop: "2%",
      fontWeight: "bold",
    },
    view: {
      position: "absolute",
      bottom: 30,
      right: 40,
      left: 40,
      textAlign: "center",
    },
  
    section: { float: "left" },
    sectionAddress: { float: "left", fontSize: 12 },
  });
  
  export function CCStatement({
    summaryData = {},
    list,
    startDate,
    endDate,
    title
  }) {
    const [firstPageData, setFirstPageData] = useState([]);
    const [pagedFilteredData, setPagedFilteredData] = useState([]);
    const [balanceDue, setBalanceDue] = useState("$0.00");

    const pageData = () => {
      const filteredList = _filter(list, (data) => {
        const transactionTime = moment(data.transactionTime).format('MM-DD-YYYY');
        return moment(transactionTime).isSameOrAfter(startDate.format('MM-DD-YYYY')) &&
          moment(transactionTime).isSameOrBefore(endDate.format('MM-DD-YYYY'))
      }).sort((a, b) => moment(a.transactionTime).isAfter(moment(b.transactionTime)) ? 1 : -1);

      const lastItem = filteredList[filteredList.length - 1];
      setBalanceDue(convertCentsIntoDollar(lastItem?.balance ?? 0));
  
      if (filteredList.length > 13) {
        setFirstPageData(_slice(filteredList, 0, 12));
        setPagedFilteredData(_chunk(_slice(filteredList, 12), 22));
      } else {
        setFirstPageData(filteredList);
      }
    }

    useEffect(() => {
      pageData();
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
      pageData();
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [startDate, endDate, list]);
  
    return (
      <>
        <Page pageNumber="1" style={{ padding: 24, display: "flex", flexDirection: "column", flex: 1 }}>
          <View
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
            }}
          >
            <View style={styles.section}>
              <Text style={styles.section1}>
                {summaryData.firstName} {summaryData.lastName}
              </Text>
              <Text style={styles.section1}>{summaryData.addressLineOne}</Text>
              <Text style={styles.section1}>{summaryData.addressLineTwo}</Text>{" "}
              <Text style={styles.section1}>{summaryData.email}</Text>
            </View>
  
            <View
              style={{
                display: "flex",
                // backgroundColor: "red",
                fontSize: 15,
                marginTop: "2%",
                alignItems: "flex-end",
              }}
            >
              <View style={{
                padding: 10,
                backgroundColor: "#FFFFFF"
              }}>
                <Svg width="107" height="60" viewBox="0 0 80 60" fill="#FFFFFF" xmlns="http://www.w3.org/2000/svg">
                  <Path d="M28.1309 0.450195L31.6561 49.5213H25.5088L20.2808 0.450195H28.1309Z" fill="#7B57E2"></Path>
                  <Path d="M34.2675 0.450195L30.3071 49.5213H35.7854L41.9327 0.450195H34.2675Z" fill="#7B57E2"></Path>
                  <Path d="M33.4962 37.6816H28.0669V48.1053H33.4962V37.6816Z" fill="#7B57E2"></Path>
                  <Path d="M9.59099 43.4593C8.454 43.4593 7.81749 42.3729 7.81749 40.6185V27.3811C7.81749 26.235 8.60086 24.7575 9.8793 24.7575H12.6266V18.625H9.63993C3.60136 18.625 0 22.5685 0 28.4023V42.0633C0 47.2127 2.40999 49.9992 6.08753 49.9992C10.0262 49.9992 11.4842 45.7407 11.8106 43.481V40.8792L11.2666 40.9444C11.272 42.4436 10.5865 43.4593 9.59099 43.4593Z" fill="#7B57E2"></Path>
                  <Path d="M9.49852 0C2.72553 0 0 5.16024 0 10.2607V16.4584H7.81749V8.62574C7.81749 7.25149 8.65527 6.56164 9.5801 6.56164C10.5049 6.56164 11.272 7.20803 11.272 8.44649V44.3563H11.9574L12.2186 49.4948H19.0895V9.7121C19.0895 3.82401 15.5534 0 9.49852 0Z" fill="#7B57E2"></Path>
                  <Path d="M52.2482 43.4593C51.1167 43.4593 50.4802 42.3729 50.4802 40.6185V27.3811C50.4802 26.235 51.2636 24.7575 52.5366 24.7575H55.2893V18.625H52.3026C46.2641 18.625 42.6572 22.5685 42.6572 28.4023V42.0633C42.6572 47.2127 45.0672 49.9992 48.7448 49.9992C52.6889 49.9992 54.1468 45.7407 54.4733 43.481V40.8792L53.9292 40.9444C53.9292 42.4436 53.2438 43.4593 52.2482 43.4593Z" fill="#7B57E2"></Path>
                  <Path d="M52.1602 0C45.3872 0 42.6345 5.16023 42.6345 10.2553V16.4584H50.4575V8.62574C50.4575 7.25149 51.2952 6.56164 52.2146 6.56164C53.134 6.56164 53.9065 7.20803 53.9065 8.44649V44.3563H54.592L54.8531 49.4948H61.7294V9.7121C61.7512 3.82401 58.2097 0 52.1602 0Z" fill="#7B57E2"></Path>
                </Svg>
              </View>
              <Text style={{ marginTop: "3%" }}>Ava Finance, Inc.</Text>
              <Text style={styles.sectionAddress}>
                548 Market St, STE 511672,
              </Text>
              <Text style={styles.sectionAddress}>
                San Francisco, CA 94104-5401
              </Text>
              <Text style={styles.sectionAddress}>www.meetava.com</Text>
            </View>
          </View>
          <View style={styles.section2}>
            {title && <Text style={styles.section1}>
              {title}
            </Text>}
            <Text style={styles.section1}>
              {`Statement Period: ${moment(startDate).format('MMM DD, YYYY')} - ${moment(endDate).format('MMM DD, YYYY')}`}
            </Text>
            <Text style={styles.section1}>
              Balance Due: {<Text style={styles.balanceDue}>{balanceDue}</Text>}
            </Text>
          </View>
  
          {(firstPageData && firstPageData.length > 0) ? (
              <View style={styles.table}>
                <View style={[styles.row, styles.bold, styles.header]}>
                  <Text style={styles.row1}>Date</Text>
                  <Text style={styles.row1}>Description</Text>
                  <Text style={styles.row1}>Amount</Text>
                </View>
                {firstPageData.map((row, i) => (
                  <View key={i} style={styles.row} wrap={false}>
                    <Text style={row.debit ? styles.row5Due : styles.row5}>{formatDate(row.transactionTime)}</Text>
                    <Text style={row.debit ? styles.row5Due : styles.row5}>{row.descriptor}</Text>
                    <Text style={row.debit ? styles.row5Due : styles.row5}>{(row.debit ? '-' : '') + convertCentsIntoDollar(row.amountInCents)}</Text>
                  </View>
                ))}
            </View>
            ) :
              <View style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <Text style={styles.section1Bold}>
                  No Statement(s) Found
                </Text>
              </View>
            }
  
          <View style={styles.view}>
            <Text style={styles.text}>
              {`Ava Finance, Inc. Credit Builder Card DOES NOT CHARGE INTEREST. This financial product is provided by Lithic Inc., a financial technology company, and their Bank Partners. To report consumer financial complaints or ask questions about your statement, please email support@meetava.com.`}
            </Text>
          </View>
        </Page>
        {
          pagedFilteredData && pagedFilteredData.length > 0 && pagedFilteredData.map((pagedData, i) => {
            return (
              <Page key={i} pageNumber={i+2}>
                <View style={styles.table}>
                  <View style={[styles.row, styles.bold, styles.header]}>
                    <Text style={styles.row1}>Date</Text>
                    <Text style={styles.row1}>Description</Text>
                    <Text style={styles.row1}>Amount</Text>
                  </View>
                  {pagedData.map((row, i) => (
                    <View key={i} style={styles.row} wrap={false}>
                      <Text style={row.debit ? styles.row5Due : styles.row5}>{formatDate(row.transactionTime)}</Text>
                      <Text style={row.debit ? styles.row5Due : styles.row5}>{row.descriptor}</Text>
                      <Text style={row.debit ? styles.row5Due : styles.row5}>{(row.debit ? '-' : '') + convertCentsIntoDollar(row.amountInCents)}</Text>
                    </View>
                  ))}
                </View>
                <View style={styles.view}>
                  <Text style={styles.text}>
                    {`Ava Finance, Inc. Credit Builder Card DOES NOT CHARGE INTEREST. This financial product is provided by Lithic Inc., a financial technology company, and their Bank Partners. To report consumer financial complaints or ask questions about your statement, please email support@meetava.com.`}
                  </Text>
                </View>
              </Page>
            );
          })
        }
      </>
    );
  }